import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id ABBC3761-B437-4800-9C57-BCBE5AC8FA31
 * name human-child
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-child.svg
 * tags
 * - People / Family 
 */
export const HumanChildIcon = createSvgIcon(<><path d="M12,2A3,3 0 0,1 15,5A3,3 0 0,1 12,8A3,3 0 0,1 9,5A3,3 0 0,1 12,2M11,22H8V16H6V9H18V16H16V22H13V18H11V22Z" /></>, 'HumanChildIcon');
export default HumanChildIcon